<template>
  <div class="conversation-details-order">
    <div class="conversation-detail-order-id">
      Order #{{ order.id }}
    </div>
    <div class="details-order-status-buttons">
      <payment-order-status :value="order.paymentStatus" small />
      <shipping-order-status :value="order.shippingStatus" small />
    </div>
    <div v-if="isSeller" class="details-order-payment-link">
      <copy-payment-change-link :id="order.id" :token="order.tokenChangePayment" :lang="order.purchaseLang" />
    </div>
    <div class="details-order-delivery-container">
      <h6>
        Delivery address:
      </h6>
      <div>
        <p>
          {{ order.address.firstName }} {{ order.address.lastName }}
        </p>
        <p>
          {{ order.address.address }}
        </p>
        <p>
          {{ order.address.postCode }} {{ order.address.city }}
        </p>
        <p>
          {{ order.address.email }}
        </p>
      </div>
      <div v-if="isSeller" class="details-order-comment">
        <template v-if="order.comment">
          {{ order.comment }}
        </template>
        <template v-else>
          <span class="no-comment">
            No order comment
          </span>
        </template>
      </div>
    </div>
    <div v-if="order.waybills.length" class="details-order-tracking-container">
      <h6>
        Tracking numbers:
      </h6>
      <div class="details-order-tracking-numbers">
        <div v-for="tracking in order.waybills" :key="tracking.id" class="details-order-tracking">
          <div class="tracking-number">
            {{ tracking.name }}
          </div>
          <b-input :value="tracking.number" size="is-small" readonly />
        </div>
      </div>
    </div>
    <div class="details-order-products-container">
      <h6>
        Products:
      </h6>
      <div class="details-order-products">
        <div v-for="(product, index) in order.orderOP" :key="`details_product_${index}`" class="details-order-product">
          <div class="details-order-product-image-name">
            <div class="details-order-product-image">
              <img v-if="product.image && product.image.small" :src="product.image.small">
            </div>
            <div class="details-order-product-name">
              {{ product.quantity }}x  {{ product.name }}
            </div>
          </div>
          <div v-if="product.sizes && product.sizes.type" class="details-order-product-dimensions">
            {{ product.sizes.width }}{{ product.sizes.type }} x {{ product.sizes.height }}{{ product.sizes.type }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CopyPaymentChangeLink from '~/marketplace-front-core/components/orders/sections/seller/CopyPaymentChangeLink'
import orderStatus from '~/marketplace-front-core/mixin/orderStatus'
export default {
  components: { CopyPaymentChangeLink },
  mixins: [orderStatus],
  props: {
    order: {
      type: Object,
      default: null
    },
    isSeller: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
$section-headers-text-color: #909091;
$tracking-number-bg-color: #F0F0F0;
.conversation-details-order {
  font-size: 14px;
  h6 {
    margin-bottom: 8px;
    color: $section-headers-text-color;
  }
  .conversation-detail-order-id {
    margin-bottom: 16px;
    font-weight: 600;
  }
  .details-order-status-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    // button {
    //   flex: 1;
    // }
    :deep(.order-status-tag) {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
  .details-order-payment-link {
    margin-top: 8px;
  }
  .details-order-delivery-container {
    margin: 16px 0;
    .details-order-comment {
      margin-top: 8px;
      padding: 6px;
      border: 1px solid #E7E8E7;
      border-radius: 4px;
      font-style: italic;
      .no-comment {
        font-size: 12px;
        color: $section-headers-text-color;
      }
    }
  }
  .details-order-tracking-container {
    margin: 16px 0;
    .details-order-tracking-numbers {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .details-order-tracking {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px 8px;
        font-size: 12px;
        background-color: $tracking-number-bg-color;
        border-radius: 4px;
        :deep(input) {
          background-color: transparent;
          border-color: transparent;
        }
      }
    }
  }
  .details-order-products-container {
    margin: 16px 0;
    .details-order-products {
      display: flex;
      flex-direction: column;
      gap: 12px;
      .details-order-product {
        .details-order-product-image-name {
          display: flex;
          align-items: center;
          gap: 8px;
          .details-order-product-image {
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            border-radius: 4px;
            background-color: #eeeeee;
          }
          .details-order-product-name {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            // white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .details-order-product-dimensions {
          margin-top: 6px;
          color: $section-headers-text-color;
        }
      }
    }
  }
}
</style>
